import { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField, {
    InputCheckbox,
    SelectOption,
    addOption
} from '../../../../../utils/InputField';
import { handleAddPackageOpe } from '../../ProductOperation';

const limitBy = [
    {
        key: 'duration',
        title: 'Duration'
    },
    {
        key: 'ppu',
        title: 'Pay Per Unit'
    },
    {
        key: 'lifetime',
        title: 'Life Time'
    }
];

function AddPackageModal({ closeModal, handleReload, data }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ApplicationId: data?.id,
        PackageName: '',
        LimitBy: '',
        Role: 'customer',
        IsPublic: false,
        Status: 'active'
    });

    // const { initInfo } = useInit();
    const { setMessage } = useTemplate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'IsPublic') {
            setFormData((d) => ({ ...d, [name]: !formData.IsPublic }));
            return;
        }
        setFormData((d) => ({ ...d, [name]: value }));
    };

    const handleEditCustomer = (e) => {
        e.preventDefault();
        setLoading(true);
        handleAddPackageOpe(data?.id, formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleEditCustomer}>
            <div className="flex flex-col gap-y-3 mb-4">
                <InputField
                    label="Package Name"
                    name="PackageName"
                    placeholder="Enter Package Name..."
                    formData={formData}
                    onChange={handleChange}
                />
                <SelectOption
                    label="Limit By"
                    name="LimitBy"
                    placeholder="Limit By..."
                    formData={formData}
                    onChange={handleChange}
                    options={limitBy.map(({ key, title }) => addOption(key, title, key))}
                />

                {/* <SelectOption
                    label="Role"
                    name="Role"
                    formData={formData}
                    onChange={handleChange}
                    options={initInfo?.roles
                        ?.filter((el) => el.key !== 'admin')
                        ?.map((item) => addOption(item?.key, item?.title, item?.key))}
                /> */}
                <InputCheckbox
                    label="IsPublic"
                    name="IsPublic"
                    formData={formData}
                    onChange={handleChange}
                    text="Is this package public?"
                />
            </div>

            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Add" btnType="submit" loading={loading} onClick={null} />
            </div>
        </form>
    );
}

export default AddPackageModal;
